import { store } from '@/iti-core-vue/store';
import { getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({
  namespaced: true,
  name: 'ItiPublicPathModule',
  store,
  dynamic: true,
})
class ItiPublicPathModule extends VuexModule {

  public publicPath: string = '';

  @Mutation
  public setPublicPath(publicPath: string) {
    this.publicPath = publicPath;
  }

}

export default getModule(ItiPublicPathModule);
